// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===========================
   Base Snackbar
   =========================== */
.snackbar {
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%) translateY(20px);
  min-width: 280px;
  max-width: 380px;
  background-color: #fff;
  border-radius: 12px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  font-family: "Segoe UI", sans-serif;
  opacity: 0;
  pointer-events: none;
  transition: all 0.35s ease;
  z-index: 9999;
}

.snackbar.show {
  opacity: 1;
  transform: translateX(-50%) translateY(0);
  pointer-events: auto;
}

.snackbar.hide {
  opacity: 0;
  transform: translateX(-50%) translateY(20px);
}

/* ===========================
   Content
   =========================== */
.snackbar-content {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
}

.snackbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1;
}

/* ===========================
   Icon
   =========================== */
.snackbar-icon {
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
  transition: transform 0.3s ease;
}

.snackbar-icon svg {
  width: 22px;
  height: 22px;
}

/* ===========================
   Texts
   =========================== */
.snackbar-title {
  margin: 0;
  font-weight: 600;
  font-size: 16px;
}

.snackbar-desc {
  margin: 0;
  font-size: 14px;
  color: #4b5563;
  line-height: 1.4;
}

/* ===========================
   Close button
   =========================== */
.snackbar-close {
  border: none;
  background: transparent;
  cursor: pointer;
  border-radius: 8px;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6b7280;
  transition: background 0.2s ease, color 0.2s ease;
}

.snackbar-close:hover {
  background-color: rgba(0,0,0,0.05);
  color: #111827;
}

/* ===========================
   Type-based colors
   =========================== */
.snackbar.success {
  background-color: #f0fdf4;
}

.snackbar.success .snackbar-icon {
  background-color: #22c55e;
}

.snackbar.success .snackbar-title,
.snackbar.success .snackbar-desc {
  color: #166534;
}

.snackbar.error {
  background-color: #fef2f2;
}

.snackbar.error .snackbar-icon {
  background-color: #ef4444;
}

.snackbar.error .snackbar-title,
.snackbar.error .snackbar-desc {
  color: #991b1b;
}

.snackbar.info {
  background-color: #eff6ff;
}

.snackbar.info .snackbar-icon {
  background-color: #3b82f6;
}

.snackbar.info .snackbar-title,
.snackbar.info .snackbar-desc {
  color: #1e40af;
}

/* ===========================
   Responsive
   =========================== */
@media (min-width: 640px) {
  .snackbar {
    min-width: 320px;
    max-width: 400px;
    font-size: 16px;
  }

  .snackbar-content {
    padding: 16px 20px;
    gap: 14px;
  }

  .snackbar-icon {
    width: 44px;
    height: 44px;
  }

  .snackbar-title {
    font-size: 17px;
  }

  .snackbar-desc {
    font-size: 15px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SnackBar/SnackBar.css"],"names":[],"mappings":"AAAA;;gCAEgC;AAChC;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,4CAA4C;EAC5C,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,uCAAuC;EACvC,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,mCAAmC;EACnC,UAAU;EACV,oBAAoB;EACpB,0BAA0B;EAC1B,aAAa;AACf;;AAEA;EACE,UAAU;EACV,yCAAyC;EACzC,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,4CAA4C;AAC9C;;AAEA;;gCAEgC;AAChC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,SAAO;AACT;;AAEA;;gCAEgC;AAChC;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;;gCAEgC;AAChC;EACE,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;;gCAEgC;AAChC;EACE,YAAY;EACZ,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE,kCAAkC;EAClC,cAAc;AAChB;;AAEA;;gCAEgC;AAChC;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;gCAEgC;AAChC;EACE;IACE,gBAAgB;IAChB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":["/* ===========================\n   Base Snackbar\n   =========================== */\n.snackbar {\n  position: fixed;\n  bottom: 20px;\n  left: 50%;\n  transform: translateX(-50%) translateY(20px);\n  min-width: 280px;\n  max-width: 380px;\n  background-color: #fff;\n  border-radius: 12px;\n  box-shadow: 0 8px 24px rgba(0,0,0,0.15);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  font-family: \"Segoe UI\", sans-serif;\n  opacity: 0;\n  pointer-events: none;\n  transition: all 0.35s ease;\n  z-index: 9999;\n}\n\n.snackbar.show {\n  opacity: 1;\n  transform: translateX(-50%) translateY(0);\n  pointer-events: auto;\n}\n\n.snackbar.hide {\n  opacity: 0;\n  transform: translateX(-50%) translateY(20px);\n}\n\n/* ===========================\n   Content\n   =========================== */\n.snackbar-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 14px 16px;\n}\n\n.snackbar-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1;\n}\n\n/* ===========================\n   Icon\n   =========================== */\n.snackbar-icon {\n  flex-shrink: 0;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.1);\n  transition: transform 0.3s ease;\n}\n\n.snackbar-icon svg {\n  width: 22px;\n  height: 22px;\n}\n\n/* ===========================\n   Texts\n   =========================== */\n.snackbar-title {\n  margin: 0;\n  font-weight: 600;\n  font-size: 16px;\n}\n\n.snackbar-desc {\n  margin: 0;\n  font-size: 14px;\n  color: #4b5563;\n  line-height: 1.4;\n}\n\n/* ===========================\n   Close button\n   =========================== */\n.snackbar-close {\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  border-radius: 8px;\n  padding: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #6b7280;\n  transition: background 0.2s ease, color 0.2s ease;\n}\n\n.snackbar-close:hover {\n  background-color: rgba(0,0,0,0.05);\n  color: #111827;\n}\n\n/* ===========================\n   Type-based colors\n   =========================== */\n.snackbar.success {\n  background-color: #f0fdf4;\n}\n\n.snackbar.success .snackbar-icon {\n  background-color: #22c55e;\n}\n\n.snackbar.success .snackbar-title,\n.snackbar.success .snackbar-desc {\n  color: #166534;\n}\n\n.snackbar.error {\n  background-color: #fef2f2;\n}\n\n.snackbar.error .snackbar-icon {\n  background-color: #ef4444;\n}\n\n.snackbar.error .snackbar-title,\n.snackbar.error .snackbar-desc {\n  color: #991b1b;\n}\n\n.snackbar.info {\n  background-color: #eff6ff;\n}\n\n.snackbar.info .snackbar-icon {\n  background-color: #3b82f6;\n}\n\n.snackbar.info .snackbar-title,\n.snackbar.info .snackbar-desc {\n  color: #1e40af;\n}\n\n/* ===========================\n   Responsive\n   =========================== */\n@media (min-width: 640px) {\n  .snackbar {\n    min-width: 320px;\n    max-width: 400px;\n    font-size: 16px;\n  }\n\n  .snackbar-content {\n    padding: 16px 20px;\n    gap: 14px;\n  }\n\n  .snackbar-icon {\n    width: 44px;\n    height: 44px;\n  }\n\n  .snackbar-title {\n    font-size: 17px;\n  }\n\n  .snackbar-desc {\n    font-size: 15px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
